import React from 'react';
import { Gauge } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface GaugeChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const GaugeChartIcon: React.FC<GaugeChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <Gauge size={size} color={color} />
        </IconWrapper>
    );
};
